import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { fetcher } from 'app/http';
import qs from 'qs';
import { useAppDispatch } from 'app/hooks';
import styles from './EmailVerificationPageData.module.scss';
import { latest } from 'immer/dist/internal';
import classNames from 'classnames/bind';
import { isNullOrWhiteSpace } from 'common/helpers/string';
import TagManager from 'react-gtm-module';
import { formProgression, formError } from 'common/helpers/Gtm';
import UpdatedFailedPopup from 'components/UpdateFailedPopup/UpdateFailedPopup';

interface Props {
  PageData?: any;
  Model?: any;
  LayoutModel?: any;
  handleClick: Function;
  handleClickEmailConfirmation: Function;
  setEditEmailConfirmationResponseData: Function;
  setEditEmailSubmitting: Function;
  setEditEmailConfirmationData: Function;
}

const EmailVerificationPageData = (props: Props) => {
  const {
    PageData,
    Model,
    LayoutModel,
    handleClick,
    handleClickEmailConfirmation,
    setEditEmailConfirmationResponseData,
    setEditEmailSubmitting,
    setEditEmailConfirmationData,
  } = props;
  const history = useHistory();
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [verificationCode, setVerificationCode] = useState<string>(Model?.FormModel?.Code || '');
  const [showUpdateFailedPopup, setShowUpdateFailedPopup] = useState<boolean>(Model?.UpdateFailed);

  function onChangeEmailClick(e: any) {
    handleClick(true);
    handleClickEmailConfirmation(false);
  }
  const getPathnameFromUrl = (url: string) => {
    const link = new URL(url);
    return link.pathname + link.search;
  };

  function editVerificationCode(e: any) {
    setVerificationCode(e.target.value);
  }

  const onResendCodeClick = async (e: any) => {
    e.preventDefault();
    try {
      let timezoneOffset = new Date().getTimezoneOffset() * -1;

      const response = await fetcher.post(
        Model.ResendCodePageUrl,

        qs.stringify({
          email: Model?.FormModel.Email,
          key: Model?.FormModel.EmailKey,
          timezoneOffsetInMinutes: timezoneOffset,
        }),
      );
      // Get pathname from enpoint url, pathname will be used for redirect and as a key in content state
      if (response && response.data?.status == 'ok') {
        //setEditEmailConfirmationResponseData(responseConfirmData.data);
        handleClick(false);
        handleClickEmailConfirmation(true);
      }
      if (response && response.data?.status === 'redirect') {
        const redirectPath = getPathnameFromUrl(response.data.data);
        history.push(redirectPath);
      }
      if (response && response.data?.status === 'error') {
        setErrorMessage(response.data.message);
        console.log(
          'error',
          isNullOrWhiteSpace(errorMessage) ? styles.show : styles.hide,
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleFormSubmit = async (e: any) => {
    e.preventDefault();
    try {
      const response = await fetcher.post(
        Model.PostCodePageUrl,
        // Convert object into string
        qs.stringify({
          'FormModel.Email': Model?.FormModel.Email,
          'FormModel.EmailKey': Model?.FormModel.EmailKey,
          'FormModel.Code': verificationCode,
        }),
      );
      if (response && response.data) {
        // Get pathname from enpoint url, pathname will be used for redirect and as a key in content state
        if (response && response.data && response.data.RedirectUrl) {
          const responseConfirmData = await fetcher.get(
            getPathnameFromUrl(response.data.RedirectUrl),
          );
          if (responseConfirmData && responseConfirmData.data) {
            setEditEmailConfirmationData(responseConfirmData.data);
            handleClick(false);
            handleClickEmailConfirmation(false);
            setEditEmailSubmitting(true);
            detailsEmailTracking();
          }
        } else if (
          response &&
          response.data &&
          response.data.status == 'error'
        ) {
          const redirectPath = getPathnameFromUrl(response.data.data);

          history.push(redirectPath);
        } else {
          setEditEmailConfirmationResponseData(response.data);
          handleClick(false);
          handleClickEmailConfirmation(true);
          setShowUpdateFailedPopup(response?.data?.Model?.UpdateFailed);
        }
      }

      // if (response && response.data) {
      //     // Get pathname from enpoint url, pathname will be used for redirect and as a key in content state
      //     if (response && response.data && response.data?.status == 'ok') {
      //         //setEditEmailConfirmationResponseData(responseConfirmData.data);
      //         handleClick(false);
      //         handleClickEmailConfirmation(true);

      //     }
      //     if (response && response.data?.status === 'redirect') {
      //         const redirectPath = getPathnameFromUrl(response.data.data);
      //         history.push(redirectPath);
      //     }
      //     if (response && response.data?.status === 'error') {
      //         setEditEmailConfirmationResponseData(response.data);
      //     }
      //     console.log("submit response data",response.data);
      // }
    } catch (err) {
      console.error(err);
    }
  };

  function cancelEditEmail(e: any) {
    handleClick(false);
    handleClickEmailConfirmation(false);
  }
  var tagManagerArgs: any;
  const detailsEmailTracking = () => {
    tagManagerArgs = {
      dataLayer: {
        event: 'edit_profile',
        edit_section: 'Email',
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  };
  return (
    <div className="Modal-content is-active">
      <form
        id="frm_sendvercode"
        onSubmit={handleFormSubmit}
        className="Form Form-inputIndent"
      >
        <div className="Grid Grid--gutterA Grid--gutter-sm-Bz">
          <div className="Grid-cell  u-lg-size1of1 u-paddingBz">
            <h3 className="Heading Heading-h3--portal u-marginBz">
              {PageData?.CustomerProfileEditHeader}
            </h3>
          </div>
          <div className="Grid-cell  u-lg-size1of2">
            <label className="Label Form-label">
              {PageData?.EmailAddressLabel}
            </label>
            <div className="Input Input-button--after Input-button--below data-hj-suppress">
              <input type="text" value={Model?.FormModel?.Email} disabled />
              <button
                id="BTN_change-email"
                onClick={(e) => onChangeEmailClick(e)}
                className="Button Input-button"
              >
                {PageData?.ChangeButtonLabel}
              </button>
            </div>
          </div>

          <div className="Grid-cell  u-lg-size1of2"></div>
        </div>
        <div className="Grid Grid--gutterA Grid--gutter-sm-Bz Grid--itemsAlignMiddle">
          <div className="Grid-cell u-lg-size1of1 u-paddingVz">
            <p className="Text--medium">{PageData?.CodeSentMessage}</p>
          </div>

          <div className="Grid-cell u-lg-size1of2">
            <label className="Label Form-label">{PageData?.CodeLabel}</label>
            <div className="Input Input--borderGreen">
              <input
                type="text"
                placeholder={Model?.PageDataBase?.CodeLabel}
                value={verificationCode}
                onChange={(e) => editVerificationCode(e)}
                onBlur={(e) => formProgression(e, 'Profile Edit Form', 'Email')}
              />
              <span></span>
            </div>
          </div>

          <div className="Grid-cell u-lg-size1of2">
            <p className="Text--small">{PageData?.ResendCodeMessage}</p>
            <a
              id="lnk-resend-code"
              onClick={(e) => onResendCodeClick(e)}
              className="Link--resend"
            >
              {PageData?.ResendCodeButtonLabel}
            </a>
            <div
              id="ajaxErrorMessage"
              className={classNames(
                isNullOrWhiteSpace(errorMessage) ? styles.show : styles.hide,
                'row error',
              )}
            ></div>
          </div>
        </div>
        <div className="Grid Grid--gutterA Grid--gutter-sm-Bz">
          <div className="Grid-cell u-lg-size1of2">
            {Model?.ShowInvalidCodeError && (
              <p className="text-danger">{PageData?.InvalidCodeError}</p>
            )}

            {Model?.ShowCodeSendingBlockedError && (
              <p className="text-danger">{PageData?.CodeSendingBlockedError}</p>
            )}
          </div>
        </div>

        <div className="Grid Grid--gutterA Grid--gutter-sm-Bz">
          <div className="Grid-cell  u-lg-size1of1">
            <div className="Customerdetails-modalButtons">
              <div className="ButtonBar  ButtonBar--spaceBetween ButtonBar--row-reverse ">
                <button type="submit" className="Button">
                  <span>{PageData?.VerifyButtonLabel}</span>
                </button>
                <button
                  type="button"
                  className="Button Button--gray js-modalclose w-100"
                  onClick={(e) => cancelEditEmail(e)}
                >
                  <span>{PageData?.CancelButtonLabel}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
      {showUpdateFailedPopup && (
        <>
          <UpdatedFailedPopup
            onClose={() => setShowUpdateFailedPopup(false)}
            {...props}
          />
        </>
      )}
    </div>
  );
};

export default EmailVerificationPageData;
